import { Component, Input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import {
  ThemeColors,
  ThemeColorVariables,
  getThemeVariables,
} from 'src/app/theme/theme-variables';

@Component({
  standalone: true,
  selector: 'icon',
  imports: [NgIcon],
  template:
    '<ng-icon [svg]="icon" [size]="size" [color]="color" class="d-flex align-items-center justify-content-center" />',
})
export class IconsComponent {
  @Input({ required: true }) icon!: string;
  @Input({ required: false }) color: ThemeColors = '';
  @Input({ required: false }) size: string = '20';

  protected colors!: ThemeColorVariables;

  ngOnInit() {
    this.colors = getThemeVariables().colors;

    if (this.color in this.colors) {
      this.color = this.colors[
        this.color as keyof typeof this.colors
      ] as ThemeColors;
    }
  }
}
